import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { errorToast, successToast } from "../../Utils/utils";
import { changeTestSetting } from "./changeTestSetting";

export class TutorTestManager{
    table:JQuery;
    tableData;
    row;

    constructor() {
        this.table = $("#as-hub-table");
        this.initDataTable();
        this.addListeners();
    }

    initDataTable(){
        const zeilen = ['ABs', 'AB'];
        this.tableData = this.table.DataTable({
            language: getTableLang({}, zeilen),
            columnDefs: [
                {"orderable": false, "targets": [1,5,6]}
            ]
        })
    }

    addListeners(){
        const self = this;
        this.table.on("click", ".load-ab", function(e){
            const col = $(this).parent();
            const abId = col.attr('data-ab');
            const row = col.parent();
            const active = self.isAbActive(abId, row)
            if (!active){
                e.preventDefault();
                errorToast('AB muss erst aktiviert werden')
            }
        });

        this.table.on("click", ".print-ab", function(e){
            const col = $(this).parent();
            const abId = col.attr('data-ab');
            const row = col.parent();
            const active  = self.isAbActive(abId, row);
            if (!active){
                e.preventDefault();
                errorToast('AB muss erst aktiviert werden');
            }
        });

        this.table.on("click", ".ab-setting", function(){
            const newStatus = ($(this).hasClass("text-success")) ? 0 : 1;
            const setting = $(this).attr('data-setting');
            const abId = $(this).parent().attr('data-ab');
            const button = $(this);
            changeTestSetting(abId, setting, newStatus, button);
        });


        this.table.on("click", ".delete-ab", function(){
            const col = $(this).parent();
            const abId = col.attr('data-ab');
            const row = col.parent();
            self.row = row;

            const confirmed = confirm("Sicher, dass du dieses Arbeitsblatt löschen möchtest?");
            if (confirmed){
                const success = function(data:any){
                    self.tableData.row(self.row).remove().draw();
                    successToast("Das AB wurde gelöscht", "Erfolg", 6500, true);
                }
                ajaxRequest('/test/' + abId + '/delete', success)
            }

        });

        this.table.on("click", ".duplicate-ab", function(){
            const parent = $(this).parent();
            const abId = parent.attr('data-ab');
            self.row = parent.parent();
            const confirmed = confirm("Sicher, dass du dieses Arbeitsblatt duplizieren möchtest?");
            if (confirmed) {

                const url = '/test/' + abId.toString() + '/duplicate'

                const success = function (data){
                    successToast('Arbeitsblatt wurde kopiert. Die Tabelle wird neu geladen', 'Erfolg', 8500, true);
                            setTimeout(function(){
                                location.reload(); // TODO: Improve -> but somehow no row is displayed, even though added?
                            }, 1800);
                }

                ajaxRequest(url, success, {}, $(this));
    
            }
        });
    }


    isAbActive(abId, row){
        const option = row.find(".ab-settings").children().first();
        return option.hasClass('text-success');
    }
}